import React from 'react';
import Modal from '@material-ui/core/Modal';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const InvoiceCostumer = ({ openModal, closeModal, isLoading }) => (
    <Modal
        open={openModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
    >
        <div className="paperAppointment-flex" style={{ width: '90%', margin: 10 }}>
            <IconButton style={{ float: 'right' }} onClick={() => {
                closeModal(false);
            }}>
                <CloseIcon />
            </IconButton>
            <div className='container-pdfs-modal'>
                <iframe className='iframe-pdfs' id="pdfV" >

                </iframe>
            </div>
        </div>
    </Modal>
);

export default InvoiceCostumer;